import script from "./ResearchView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ResearchView.vue?vue&type=script&lang=ts&setup=true"

import "./ResearchView.vue?vue&type=style&index=0&id=410ddf11&scoped=true&lang=scss"
import "./ResearchView.vue?vue&type=style&index=1&id=410ddf11&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-410ddf11"]])

export default __exports__